import React from "react";
import { Box, styled, SxProps, Theme } from "@mui/material";

export const COLOR_BOX_SIZE = 40;

export const colorRowSx: SxProps<Theme> = {
  display: "flex",
  alignItems: "flex-start",
  gap: 1.5,
};

const BOX_RADIUS = 8;

const boxBaseSx: SxProps<Theme> = {
  width: COLOR_BOX_SIZE,
  height: COLOR_BOX_SIZE,
  flexShrink: 0,
  borderRadius: `${BOX_RADIUS}px`,
  border: "1px solid",
  borderColor: "divider",
  overflow: "hidden",
};

const ColorInput = styled("input")(({ theme }) => ({
  width: COLOR_BOX_SIZE,
  height: COLOR_BOX_SIZE,
  flexShrink: 0,
  padding: 0,
  margin: 0,
  background: "none",
  cursor: "pointer",
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: `${BOX_RADIUS}px`,
  overflow: "hidden",
  "&::-webkit-color-swatch-wrapper": {
    padding: 0,
    borderRadius: `${BOX_RADIUS - 1}px`,
  },
  "&::-webkit-color-swatch": {
    border: "none",
    borderRadius: `${BOX_RADIUS - 1}px`,
  },
  "&::-moz-color-swatch": {
    border: "none",
    borderRadius: `${BOX_RADIUS - 1}px`,
  },
}));

interface ColorPickerInputProps {
  value: string;
  ariaLabel: string;
  onChange: (hex: string) => void;
}

export const ColorPickerInput: React.FC<ColorPickerInputProps> = ({
  value,
  ariaLabel,
  onChange,
}) => (
  <ColorInput
    type="color"
    value={value}
    onChange={(e) => onChange(e.target.value)}
    aria-label={ariaLabel}
  />
);

interface ColorSwatchProps {
  color?: string;
  gradient?: string;
  width?: number;
}

export const ColorSwatch: React.FC<ColorSwatchProps> = ({
  color,
  gradient,
  width,
}) => (
  <Box
    sx={{ ...boxBaseSx, ...(width ? { width } : {}) }}
    style={
      gradient ? { backgroundImage: gradient } : { backgroundColor: color }
    }
  />
);
